module.exports = __webpack_public_path__ + "fonts/unknown-device@2x.2c67cc8b770105c89c9c7ffb0787e814.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/security/unknown-device@2x.png
// module id = 793
// module chunks = 9